<div class="ion-page" style="overflow-y: hidden !important;">
  <ion-header>
    <ion-toolbar style="text-align: center;" color="secondary">
      <ion-title>
        <ion-icon name="document-outline" class="title-icon"></ion-icon>
        {{ 'Exporting report' | translate }}
      </ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-content color="secondary">
    <div class="export-progress-container">

      <div class="format-badge">
        <ion-icon name="document-text-outline"></ion-icon>
        <span>{{ format }}</span>
      </div>

      <div class="percentage-text">{{ progress }}%</div>

      <div class="progress-bar-track">
        <div class="progress-bar-fill" [style.width.%]="progress"></div>
      </div>

      <p class="hint-text">{{ 'Please wait while your report is being exported...' | translate }}</p>

    </div>
  </ion-content>
</div>
